var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/react/ConsentBanner.tsx
import React, { useEffect, useContext } from "react";

// src/react/context.ts
import { createContext } from "react";
var ConsentContext = createContext({
  providerId: void 0,
  language: void 0,
  necessary: false,
  preferences: false,
  statistics: false,
  marketing: false,
  consented: false,
  declined: false,
  hasResponse: false,
  doNotTrack: false
});

// src/react/ConsentBanner.tsx
var ConsentBannerElementId = "CookieConsentWrapper";
var ConsentBanner = _ref => {
  let {
    language: overrideLanguage
  } = _ref;
  const context = useContext(ConsentContext);
  const {
    providerId,
    language: contextLanguage
  } = context;
  useEffect(() => {
    const wrapper = document.getElementById(ConsentBannerElementId);
    const script = document.createElement("script");
    script.id = "CookieConsent";
    script.async = true;
    script.setAttribute("data-testid", "consent-script");
    const url = new URL("https://consent.cookiebot.com/uc.js");
    if (wrapper && providerId) {
      url.searchParams.append("cbid", providerId);
      script.src = url.toString();
      if (overrideLanguage) {
        script.setAttribute("data-culture", overrideLanguage);
      } else if (contextLanguage) {
        script.setAttribute("data-culture", contextLanguage);
      }
      wrapper.appendChild(script);
    }
    return () => {
      if (wrapper && providerId) {
        wrapper.removeChild(script);
      }
    };
  }, [providerId, overrideLanguage, contextLanguage]);
  return /* @__PURE__ */React.createElement("div", {
    id: ConsentBannerElementId
  });
};
var ConsentBanner_default = ConsentBanner;

// src/react/use-consent.ts
import { useContext as useContext2 } from "react";
var useConsent = () => useContext2(ConsentContext);

// src/react/ConsentPreferences.tsx
import React2, { useEffect as useEffect2, useContext as useContext3 } from "react";
var ConsentPreferencesElementId = "CookiePreferencesWrapper";
var ConsentPreferences = _ref2 => {
  let {
    language: overrideLanguage
  } = _ref2;
  const context = useContext3(ConsentContext);
  const {
    providerId,
    language: contextLanguage
  } = context;
  useEffect2(() => {
    const wrapper = document.getElementById(ConsentPreferencesElementId);
    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = "https://consent.cookiebot.com/".concat(providerId, "/cd.js");
    script.setAttribute("data-testid", "consent-preferences");
    script.async = true;
    if (overrideLanguage) {
      script.setAttribute("data-culture", overrideLanguage);
    } else if (contextLanguage) {
      script.setAttribute("data-culture", contextLanguage);
    }
    if (wrapper) {
      wrapper.appendChild(script);
    }
    return () => {
      if (wrapper) {
        wrapper.removeChild(script);
      }
    };
  }, [providerId, overrideLanguage, contextLanguage]);
  return /* @__PURE__ */React2.createElement("div", {
    id: ConsentPreferencesElementId
  });
};
var ConsentPreferences_default = ConsentPreferences;

// src/react/ConsentProvider.tsx
import React3, { useState, useEffect as useEffect3, useCallback } from "react";
var COOKIEBOT_EVENTS = ["CookiebotOnConsentReady", "CookiebotOnLoad", "CookiebotOnAccept", "CookiebotOnDecline", "CookiebotOnDialogInit", "CookiebotOnDialogDisplay", "CookiebotOnTagsExecuted"];
var ConsentProvider = _ref3 => {
  let {
    children,
    providerId,
    language
  } = _ref3;
  const [context, setContext] = useState({
    providerId,
    language,
    necessary: false,
    marketing: false,
    preferences: false,
    statistics: false,
    consented: false,
    declined: false,
    hasResponse: false,
    doNotTrack: false
  });
  const updateConsent = useCallback(() => {
    const cookiebot = window.Cookiebot;
    if (!cookiebot) {
      return;
    }
    setContext(__spreadProps(__spreadValues({}, context), {
      necessary: cookiebot.consent.necessary,
      marketing: cookiebot.consent.marketing,
      preferences: cookiebot.consent.preferences,
      statistics: cookiebot.consent.statistics,
      consented: cookiebot.consented,
      declined: cookiebot.declined,
      hasResponse: cookiebot.hasResponse,
      doNotTrack: cookiebot.doNotTrack
    }));
  }, [context]);
  useEffect3(() => {
    if (typeof window !== "undefined") {
      COOKIEBOT_EVENTS.forEach(event => {
        window.addEventListener(event, updateConsent);
      });
    }
    return () => {
      if (typeof window !== "undefined") {
        COOKIEBOT_EVENTS.forEach(event => {
          window.removeEventListener(event, updateConsent);
        });
      }
    };
  }, [updateConsent]);
  return /* @__PURE__ */React3.createElement(ConsentContext.Provider, {
    value: context
  }, children);
};
var ConsentProvider_default = ConsentProvider;
export { ConsentBanner_default as ConsentBanner, ConsentContext, ConsentPreferences_default as ConsentPreferences, ConsentProvider_default as ConsentProvider, useConsent };